import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ONEGO_LOGO } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const fillDemo = () => {
        setEmail("merchant@onego.africa");
        setPassword("merchant1234");
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success(`Welcome back, ${res.user.name}`);
            const r = res.user.role;
            const defaultTo =
                r === "admin" ? "/admin" :
                r === "super_agent" ? "/agent" :
                r === "supplier" ? "/supplier" : "/dashboard";
            const to = location.state?.from?.pathname || defaultTo;
            navigate(to);
        } else {
            setError(res.error);
            toast.error(res.error);
        }
    };

    return (
        <div className="min-h-screen og-gradient-soft flex items-center justify-center px-6 py-12" data-testid="login-page">
            <div className="w-full max-w-md og-card p-8">
                <Link to="/" className="inline-flex items-center" data-testid="login-logo-link">
                    <img src={ONEGO_LOGO} alt="OneGo" className="h-10 w-auto" />
                </Link>
                <h1 className="mt-6 font-display font-extrabold text-3xl text-onego-navy">Welcome back</h1>
                <p className="mt-2 text-slate-600">Sign in to your merchant account.</p>

                <form onSubmit={onSubmit} className="mt-6 space-y-4">
                    <div>
                        <label className="text-sm font-semibold text-onego-navy">Email</label>
                        <input
                            type="email"
                            className="og-input mt-1"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@business.africa"
                            required
                            data-testid="login-email-input"
                        />
                    </div>
                    <div>
                        <label className="text-sm font-semibold text-onego-navy">Password</label>
                        <input
                            type="password"
                            className="og-input mt-1"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"
                            required
                            minLength={6}
                            data-testid="login-password-input"
                        />
                    </div>
                    {error && <p className="text-sm text-rose-600 font-semibold" data-testid="login-error">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        className="og-btn-gradient w-full disabled:opacity-60"
                        data-testid="login-submit-btn"
                    >
                        {loading ? "Signing in\u2026" : "Sign in"}
                    </button>
                </form>

                <button
                    onClick={fillDemo}
                    type="button"
                    className="mt-4 w-full text-sm font-semibold text-onego-navy underline underline-offset-4 hover:text-pink-600"
                    data-testid="login-demo-fill"
                >
                    Use demo merchant credentials
                </button>

                <p className="mt-6 text-sm text-slate-600">
                    New to OneGo?{" "}
                    <Link to="/register" className="font-bold text-onego-navy hover:text-pink-600" data-testid="login-register-link">
                        Create an account
                    </Link>
                </p>
                <p className="mt-2 text-sm text-slate-600">
                    Forgot your password?{" "}
                    <Link to="/forgot-password" className="font-bold text-onego-navy hover:text-pink-600" data-testid="login-forgot-link">
                        Reset it
                    </Link>
                </p>
            </div>
        </div>
    );
}
